import axios from "axios";
import { ChiroIntake } from "../types/Forms";
import { handleResponse, handleError } from "./apiUtils";
import { getAccessToken } from "../utils/auth/authApiUtils";
import { getBaseApiUrl } from "./apiHelper";
import API_CONSTANTS from "./apiConstants"

export async function submitChiroIntakeForm(formData: ChiroIntake) {
  const baseUrl = getBaseApiUrl();
  const token = await getAccessToken();

  return axios
    .post(
      baseUrl + "v1/securedocui/chirointakeform/SubmitIntakeForm",
      formData,
      {
        headers: {
          Accept: "application/json",
          ContentType: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    )
    .then(handleResponse)
    .catch(handleError);
}

export const saveChiroIntakeForm = async (formData: ChiroIntake) => {
  const baseUrl = getBaseApiUrl();
  const token = await getAccessToken();

  return axios
    .post(
      baseUrl + "v1/securedocui/chirointakeform/SaveIntakeForm",
      formData,
      {
        headers: {
          Accept: "application/json",
          ContentType: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    )
    .then(handleResponse)
    .catch(handleError);
}

export const getIntakeForm = async (
  formId: string,
  organizationId: string,
  claimNumber: string) => {
    
  const url = `${getBaseApiUrl()}${API_CONSTANTS.INTAKE_FORM.GET}?FormId=${formId}&OrganizationId=${organizationId}&ClaimNumber=${claimNumber}`;  
  const token = await getAccessToken();

  return axios.get(url, {
      responseType: "json",
        headers: {
          Accept: "application/json",
          ContentType: "application/json",
          Authorization: "Bearer " + token,
        }
    })
    .then(handleResponse)
    .catch(handleError);
}

